const handleShowMacOnuInformation = ({AddressIp, OnuMarca, Onu})=>(
    new Promise((resolve, reject)=>{
        fetch('/api/ShowMacOnuInformation',{
            method:'POST',
            body: JSON.stringify({IPCLIENTE:AddressIp, OnuMarca, Onu}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            console.log(result)
            if(result.message){
                resolve(result.message)
            }else{
                reject(result.status)
            } 
        }); 
    }).then((info)=>{
        return {message:info};
    }).catch((err)=>{
        return {status:err};
    })

);

export default handleShowMacOnuInformation;